import momentLib from "moment";

const moment = (date) => {
  if (!date) return "";
  return momentLib(date).fromNow();
};

export default moment;
